// src/App.js
import React, { useState } from "react";
import sonnyAngel from "./SNA.webp";
import "./App.css";

function App() {
  const [email, setEmail] = useState("");
  const [product, setProduct] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);  // start spinner
    setMessage("");    // clear old messages
  
    if (!product.startsWith("https://sonnyangelusa.com/")) {
      setMessage("Please enter a valid SonnyAngel product link.");
      setSuccess(false);
      setLoading(false);
      return;
    }
  
    const response = await fetch("https://sonnyweb.onrender.com/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, product }),
    });
  
    const data = await response.json();
  
    if (response.ok) {
      setSuccess(true);
      setMessage(`✨ You're subscribed! We'll email you when this item drops.`);
      setEmail("");
      setProduct("");
    } else {
      setSuccess(false);
      setMessage(data.message || "Subscription failed — please try again.");
    }
  
    setLoading(false); // stop spinner
  };

  return (
    <div className="app-container">
      <div className="header">
        {/* <img
          src= {sonnyAngel}
          alt="Sonny Angel"
          className="logo"
        /> */}
        <h1>Sonny Drop Alerts</h1>
        <p>Get notified instantly when your Sonny Angel is back in stock!</p>
      </div>

      <form className="form-card" onSubmit={handleSubmit}>
        <label>Email Address</label>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Product Link</label>
        <input
          type="text"
          placeholder="https://sonnyangelusa.com/collections/.../products/..."
          value={product}
          onChange={(e) => setProduct(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? (
            <div className="spinner"></div>
          ) : (
            "Notify Me 💌"
          )}
        </button>

        {message && (
          <div className={`alert ${success ? "success" : "error"}`}>
            {message}
          </div>
        )}
      </form>
      
  

      <footer>
        <p>
          Built with ❤️ for Sonny Angel collectors  
          <br />
          <a href="https://github.com/maxpenaaa" target="_blank" rel="noreferrer">
            By Max Peña 
          </a>
          <br />
          <a
              href="https://buymeacoffee.com/maxpenaaa"
              target="_blank"
              rel="noopener noreferrer"
              className="coffee-button"
            >
               ☕ Buy me a coffee
          </a>
        </p>
      </footer>
    </div>
  );
}

export default App;